// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import RotatingCard from "examples/Cards/RotatingCard";
import RotatingCardFront from "examples/Cards/RotatingCard/RotatingCardFront";
import RotatingCardBack from "examples/Cards/RotatingCard/RotatingCardBack";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

// Images
import bgFront from "assets/images/card-1.png";
import bgBack from "assets/images/card-2.png";

function Information() {
  return (
    <MKBox component="section" py={6} my={6}>
      <Container>
        <Grid container item xs={11} spacing={3} alignItems="center" sx={{ mx: "auto" }}>
          <Grid item xs={14} lg={4} sx={{ mx: "auto" }}>
            <RotatingCard>
              <RotatingCardFront
                image={bgFront}
                icon="touch_app"
                title={
                  <>
                    Breaking Boundaries
                    <br />
                    With Innovation!
                  </>
                }
                description="Get Ready to Level Up with Our Game-Changing Services Tailored Just for YOU!"
              />
              <RotatingCardBack
                image={bgBack}
                title="Discover More:"
                description={
                  <>
                    ✅ Customized Solutions <br />
                    ✅ Expert Team <br />
                    ✅ Latest Tech <br /> ✅ Customer-First Approach
                  </>
                }
                action={{
                  type: "internal",
                  route: "/sections/page-sections/page-headers",
                  label: "Let's Turn Your Vision into Reality!",
                }}
              />
            </RotatingCard>
          </Grid>
          <Grid item xs={12} lg={7} sx={{ ml: "auto" }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="website"
                  title="Web-Site Developmet"
                  description="Create stunning, custom webs that captivate your audience, visitors into loyal customers with seamless experiences."
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="devices"
                  title="Mobile App Development"
                  description="Bring your app ideas to life with intuitive, high-performing mobile applications for iOS and Android, boosting engagement."
                />
              </Grid>
            </Grid>
            <Grid container spacing={3} sx={{ mt: { xs: 0, md: 6 } }}>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="code"
                  title="Software Development"
                  description="Build scalable software tailored to your business, enhancing efficiency and driving innovation with cutting-edge solutions."
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="memory"
                  title="AI & ML Development"
                  description="Leverage AI & ML to transform data into actionable insights, automating tasks and driving smarter business decisions."
                />
              </Grid>
            </Grid>
            <Grid container spacing={3} sx={{ mt: { xs: 0, md: 6 } }}>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="shoppingcart"
                  title="E-commerce Development"
                  description="Supercharge your e-commerce platform with a seamless, user-focused design that maximizes sales and growth potential."
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="sensors"
                  title="IoT Development"
                  description="Connect & streamline operations with IoT development, enhancing productivity, security, and system integration."
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
